import React from 'react';

import { useDropDownContext } from './drop-down-context';
import type { TDropDown } from './models';

const DEFAULT_MARGIN_LEFT = 16;

export const DropDown = ({
    MainMenu,
    banner,
    containerRef,
    dropDownBannerData,
    dropDownData,
    styles,
}: TDropDown) => {
    const { leftShift } = useDropDownContext();
    const marginLeft = leftShift + DEFAULT_MARGIN_LEFT;

    if (!dropDownData) return null;

    return (
        <>
            <div
                ref={containerRef}
                className={styles.dropDownHitbox}
                style={{ marginLeft: -marginLeft }}
            >
                <div className={styles.dropDown}>
                    <MainMenu
                        banner={banner}
                        bannerProps={dropDownBannerData}
                        menuItems={dropDownData}
                    />
                </div>
            </div>
        </>
    );
};
